import { UserManager, WebStorageStateStore } from "oidc-client-ts";

const authority =
  process.env.REACT_APP_KEYCLOAK_AUTHORITY ||
  "https://keycloak.vienna.local/realms/clubradar";

const appUrl = process.env.REACT_APP_URL || "http://localhost:3000";

export const userManager = new UserManager({
  authority,
  client_id: "admin-dashboard",
  redirect_uri: `${appUrl}/auth/callback`,
  post_logout_redirect_uri: `${appUrl}/`,
  silent_redirect_uri: `${appUrl}/auth/silent-renew`,
  response_type: "code",
  scope: "openid profile email",
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  automaticSilentRenew: true,
});
